module.exports = __webpack_public_path__ + "static/media/Fr. Stephen.69a074ff.png";